<template>
  <div class="notification-template-management">
    <el-menu
      router
      class="menu-list"
      mode="horizontal"
      :default-active="activeIndex"
    >
      <el-menu-item
        v-for="(item, index) in tabList"
        class="menu-item"
        :key="index"
        :index="item.path"
      >
        {{ item.title || $t(item.i18nTitle) }}
      </el-menu-item>
    </el-menu>
    <router-view class="content"/>
  </div>
</template>

<script>
import _ from 'lodash'
import { tabMenuRoute } from './route'

export default {
  components: {
  },
  props: {

  },
  data () {
    return {
      activeIndex: null,
      i18nPrefix: 'admin.company.notification'
    }
  },
  computed: {
    activeTab () {
      return this.$route.query.tab
    },
    tabList () {
      return _.map(tabMenuRoute.children, (item) => {
        return {
          path: item.path,
          i18nTitle: item.meta.tabMenuLabelI18nKey
        }
      })
    }
  },
  created () {

  },
  methods: {

  },
  watch: {
    $route: {
      immediate: true,
      handler () {
        this.activeIndex = this.$route.path
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.notification-template-management {
  position: relative;

  .menu-list {
    .menu-item {
      font-size: 14px;
      line-height: 30px;
      padding: 0;
      margin: 0 20px;
      height: 30px;

      &:first-child {
        margin-left: 0;
      }
    }

    .menu-item.is-active {
      color: #0096cc;
      border-bottom: 1px solid #0096cc;
    }
  }

  .content {
    padding-top: 20px;
  }
}
</style>
